import type { FaireProductEntity } from "../../entity_types/product";

export const toysmith_4: FaireProductEntity = {
  token: "toysmith-4",
  type: "product",
  name: "Playground Classics Big Bubble Wand Set",
  brandName: "Toysmith",
  imageUrl:
    "https://cdn.faire.com/fastly/76b4266c7cda2f4e5ee69e4b9e88a252b6834f56d1fdf25379a36d400f1bcb4e.jpeg?bg-color=FFFFFF&canvas=720:720&dpr=1&fit=bounds&format=jpg&height=720&width=720",
  priceDollars: 9,
  msrpDollars: 18,
  freeShipping: false,
  isBestseller: false,
  description: "",
  categoryTokens: ["cat_kids-toys"],
  tags: [],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
